import React, { useContext } from "react"
import PropTypes from "prop-types"
import Email from "./Email"
import { DataContext } from "../contexts/DataContext";

function OfficeHours({}) {

  const { isLoaded, currentSemester } = useContext(DataContext);
  if(!isLoaded) {
    return <div className="officeHours"><h2>Office Hours</h2></div>
  }



  return (
    <div className="officeHours">
      <h2>{currentSemester['name']} Office Hours</h2>
      <ul>
        {currentSemester.officeHours.map((officeHour, i) =>
          <li key={i}><strong>{officeHour.day}:</strong> {officeHour.time}, {officeHour.location}</li>
        )}

        <li><strong>By appointment:</strong> <Email text="email" /> to arrange</li>
      </ul>
    </div>
  )
}


OfficeHours.propTypes = {
};

OfficeHours.defaultProps = {
};


export default OfficeHours;
